module.exports = __webpack_public_path__ + "static/logo_ligth_red-2955594a55730eac4473616ac1dfa5e5.png";